import React from 'react';
import {
	Route,
	Navigate,
	RouterProvider,
	createBrowserRouter,
	createRoutesFromElements
} from 'react-router-dom';
// ---- external imports ------

import { AuthRoute, GuardedRoute } from '~/authentication/routes';
import GameMounter from '~/GameLauncher/GameMounter';
import {
	LoginPage,
	EmailActionPage,
	ForgotPasswordPage,
} from '~/authentication';
import axiosInterceptorService from '~/services/axiosInterceptor.service';
// ---- internal imports ------

import './authFonts.css';
// ---- local imports ------

// Built once, at module scope.
//
// `createBrowserRouter` was called from inside `App`'s render body, so a new
// router was built on every render — and `App` re-renders on every change to
// `UserContext`, because `LogRocketProvider` reads that context and sits
// directly above it. Restoring a session, logging a player in, each auth
// request opening and closing: every one of those rebuilt the router, several
// times over before a cold load had settled.
//
// Each rebuild is more than waste:
//
//   - `RouterProvider` memoises its `navigator` on the router object, and
//     `useNavigate()` is memoised on the navigator. A new router changes both
//     identities, so every effect keyed on `useNavigate()` runs again.
//     `EmailLoginRedirector` keys its mount effect that way, which is how one
//     single-use `oobCode` came to be exchanged twice.
//   - `RouterProvider` seeds the state it renders from the first router it is
//     handed (`useState(router.state)`) and re-subscribes to each new one. A
//     navigation still in flight on the router being replaced has nobody
//     listening when it resolves.
//   - `createBrowserRouter` calls `initialize()`, which attaches a history
//     listener, and nothing calls `dispose()` on the routers that are dropped.
//     They stay subscribed to `popstate` for the life of the page.
//
// Nothing in here reads props, state or context, so module scope is where it
// belongs — and being built once is what the rest of the router's own
// behaviour assumes.
const router = createBrowserRouter(
	createRoutesFromElements(

		<Route>
			{/* `hasLinkActions`: the one route whose screens spend an `oobCode`, so
			    the one route a pending code may hold open against the redirect a
			    live session would otherwise trigger. */}
			<Route path="emailAction" element={<AuthRoute path="/emailAction" hasLinkActions component={EmailActionPage} ></AuthRoute>} />
			<Route path="forgot" element={<AuthRoute path="/forgot" isUsingWhiteBackground component={ForgotPasswordPage} ></AuthRoute>} />
			<Route path="login" element={<AuthRoute path="/login" isUsingWhiteBackground component={LoginPage} ></AuthRoute> } />
			<Route path="/">
				<Route path='game/*' element={<GuardedRoute path="/game" component={GameMounter} />} />
				<Route path="/" element={<Navigate to="/login" />} />
			</Route>
			<Route path='*' element={<Navigate to="/login" />} />
		</Route>
	)
);

function App() {
	// Initialize axios interceptor service
	React.useEffect(() => {
		axiosInterceptorService.init();
	}, []);

	return (
		<RouterProvider router={router} />
	);
}

export default App;
